import { request } from '../utils/request';

export const fetchRabbitQueues = () =>
  request.get('/superadmin/rabbitmq/queues').then(r => r.data);

export const fetchRabbitMessageLog = params =>
  request.get('/superadmin/rabbitmq/message-log', { params }).then(r => r.data);

export const retryRabbitMessage = body =>
  request
    .post('/superadmin/rabbitmq/message-log/retry', body)
    .then(r => r.data);

export const fetchRabbitSummary = params =>
  request.get('/superadmin/rabbitmq/summary', { params }).then(r => r.data);

export const fetchRabbitAlerts = params =>
  request.get('/superadmin/rabbitmq/alerts', { params }).then(r => r.data);

export const acknowledgeRabbitAlert = (alertId, body) =>
  request
    .post(`/superadmin/rabbitmq/alerts/${alertId}/acknowledge`, body)
    .then(r => r.data);

export const triggerDummyWorkerTask = params =>
  request.get('/worker/dummy-task', { params }).then(r => r.data);
